import { useEffect, useState } from 'react';

import { getStockPosition } from '../../../../services/inventory/transfersApi';
import { notifyApiError } from '../../../../utils/feedback';

// ---------------------------------------------------------------------------
// Posição de estoque da ORIGEM como mapa prod_id → disponível — alimenta as
// colunas informativas "Disponível na origem"/"Sobra" (decisão D3: NUNCA gate;
// o backend permite reservar acima do disponível).
//
// Extraído de TransferOrderNew em 2026-09-10, quando a edição (fase 2) passou
// a precisar do mesmo dado. `null` = sem PDV escolhido OU carga falhou —
// fail-open: as colunas somem e nada trava, mesma postura da barreira de PDV.
// ---------------------------------------------------------------------------

export function useOriginAvailability(pdvId) {
   const [availability, setAvailability] = useState(null);

   useEffect(() => {
      if (!pdvId) {
         setAvailability(null);
         return undefined;
      }
      let alive = true;
      (async () => {
         try {
            const positions = await getStockPosition({ pdvId });
            if (!alive) return;
            const map = {};
            positions.forEach((position) => {
               map[position.prod_id] = Number(position.available_qtd) || 0;
            });
            setAvailability(map);
         } catch (err) {
            if (!alive) return;
            setAvailability(null);
            notifyApiError(err, {
               fallback:
                  'Não foi possível carregar o disponível da origem — a operação segue normalmente.',
            });
         }
      })();
      return () => {
         alive = false;
      };
   }, [pdvId]);

   return availability;
}
